export default __webpack_public_path__ + "static/media/WayneState.47f48346.jpeg";